import { Helmet } from "react-helmet";
/**
 * Shared base component to fill screen
 */
type FullBleedSetupProps = {
  children: React.ReactNode;
};

export default function FullBleedSetup({ children }: FullBleedSetupProps) {
  return (
    <div className="full-bleed-setup" sx={{ height: "100vh", position: "relative" }}>
      <Helmet>
        <meta
          name="viewport"
          key="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover"
        />
      </Helmet>
      {/*
        Fairly strong assumption, but since we're in a mobile webview, assume we don't want
        users selecting any text
      */}
      <style>{`.full-bleed-setup :not(input):not(textarea) { -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; }`}</style>

      {children}
    </div>
  );
}
